<template>
  <div class="pact">
    <p class="title">
      申请城市合伙人协议合同
    </p>
    <p class="content">
      亲爱的用户，在您注册的康富美用户的过程中，您需要完成我
      们的注册流程并通过点击同意的形式在线签署康富美《隐私协议》
      和《隐私政策》，请务必填写阅读，充分裂解协议中的条款内容后
      再点击同意，尤其是加粗字体
                          
    </p>
    <p class="content1">
      亲爱的用户，在您注册的康富美用户的过程中，您需要完成我
      们的注册流程并通过点击同意的形式在线签署康富美;        
    </p>
    <p class="choice-box">
      <van-checkbox v-model="checked" checked-color="#ffc201" icon-size="18px"></van-checkbox>点击同意即代表您已阅读<span>《服务协议》</span>                           
    </p>
    <p class="btn">
      <img src="../../assets/images/partner-img/6.png" alt="">
      <img src="../../assets/images/partner-img/7.png" alt="" @click="next_btn">
    </p>
    <!-- <p class="phone">
      <img src="../../assets/images/partner-img/8.png" alt="">联系方式：400-6556-376
    </p> -->
    <contactWay></contactWay>
  </div>
</template>

<script>

import contactWay from '../../components/partner/contact-way'

import Vue from 'vue';
import { Checkbox, CheckboxGroup, Toast } from 'vant';

Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Toast);

export default {
  data(){
    return{
      checked : false,
      uid : ''
    }
  },
  props:[
    'level_id',
    'id'
  ],
  components:{
    contactWay
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));

  },
  methods:{
    // 同意并继续
    next_btn(){
      if(!this.level_id){
        Toast('请选择地域级')
      }else if( !this.checked){
        Toast('请确认同意用户服务协议')
      }else{
        // this.$router.replace('/authentication')
        // console.log(this.level_id)
        // this.$axios.post(this.domain.url+'/api/pay/index/wxPay',{
        //   uid : 55,
        //   type : 6,
        //   partner_id : this.id,
        //   level_id : this.level_id
        // }).then((res) =>{
        //   console.log(res)
        // })
        let pay_url = 'http://members.kfm666666.net/api/pay/index/wxpay/?uid=' + this.uid + '&type=' + '6' + '&partner_id=' + this.id + '&level_id=' + this.level_id
        // console.log(pay_url)
        window.location.replace(pay_url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
  // 合同
  .pact{
    width: 7.1rem;
    background: #fff;
    margin: 0 auto;
    border-radius: .1rem;
    margin-top: .1rem;
    margin-bottom: .2rem;
    .title{
      font-size: 0.26rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #0C0C0C;
      text-align: center;
      margin-top: .4rem;
    }
    .content,.content1{
      width: 6.37rem;
      margin: 0 auto;
      font-size: 0.22rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #A1A1A1;
      line-height: 0.36rem;
    }
    .content{
      margin-top: .3rem;
    }
    .content1{
      margin-top: .18rem;
    }
    .choice-box{
      display: flex;
      align-items: center;
      margin-left: .3rem;
      margin-top: .3rem;
      font-size: 0.24rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #212121;
      .van-checkbox{
        margin-right: .2rem;
      }
      span{
        color: #6B9FFF;
      }
    }
    .btn{
      display: flex;
      align-items: center;
      margin-top: .4rem;
      img{
        &:first-child{
          width: 2.29rem;
          height: .6rem;
          margin-left: 1.04rem;
        }
        &:last-child{
          width: 2.42rem;
          height: .72rem;
          margin-left: .35rem;
        }
      }
    }
    .phone{
      font-size: 0.2rem;
      font-family: PingFang SC;
      font-weight: 300;
      color: #A7A7A7;
      text-align: center;
      line-height: .2rem;
      margin-top: .7rem;
      margin-bottom: .3rem;
      img{
        width: .17rem;
        height: .19rem;
        margin-right: .2rem;
      }
    }
  }
</style>